export const HTTP_ERROR_MESSAGES: Record<number, string> = {
  400: 'La solicitud contiene datos incorrectos. Por favor, revisa la información proporcionada.',
  401: 'Tu sesión ha expirado. Por favor, vuelve a iniciar sesión.',
  403: 'No tienes permiso para realizar esta acción.',
  404: 'El recurso solicitado no fue encontrado.',
  408: 'La solicitud ha excedido el tiempo de espera. Por favor, inténtalo nuevamente.',
  409: 'Hay un conflicto con el estado actual del recurso.',
  422: 'No se pudo procesar la solicitud. Verifica los datos ingresados.',
  429: 'Has realizado demasiadas solicitudes. Por favor, espera un momento e intenta nuevamente.',
  500: 'Ha ocurrido un error en el servidor. Estamos trabajando para solucionarlo.',
  502: 'El servicio no está disponible temporalmente. Por favor, inténtalo más tarde.',
  503: 'El servicio no está disponible. Por favor, inténtalo más tarde.',
  504: 'Se agotó el tiempo de espera del servidor. Por favor, inténtalo nuevamente.',
};

export const GENERIC_ERROR_MESSAGE =
  'Ha ocurrido un error inesperado. Por favor, inténtalo nuevamente.';

/**
 * Translation map for common validation error messages from English to Spanish
 */
export const VALIDATION_ERROR_TRANSLATIONS: Record<string, string> = {
  // Email validation errors
  'The email has already been taken.': 'El correo electrónico ya está en uso.',
  'The email field is required.':
    'El campo de correo electrónico es obligatorio.',
  'The email must be a valid email address.':
    'El correo electrónico debe ser una dirección válida.',
  'The email format is invalid.':
    'El formato del correo electrónico es inválido.',

  // Password validation errors
  'The password field is required.': 'El campo de contraseña es obligatorio.',
  'The password must be at least 8 characters.':
    'La contraseña debe tener al menos 8 caracteres.',
  'The password confirmation does not match.':
    'La confirmación de contraseña no coincide.',
  'The password must contain at least one uppercase letter.':
    'La contraseña debe contener al menos una letra mayúscula.',
  'The password must contain at least one lowercase letter.':
    'La contraseña debe contener al menos una letra minúscula.',
  'The password must contain at least one number.':
    'La contraseña debe contener al menos un número.',
  'The password must contain at least one special character.':
    'La contraseña debe contener al menos un carácter especial.',

  // Name validation errors
  'The name field is required.': 'El campo de nombre es obligatorio.',
  'The first name field is required.': 'El campo de nombre es obligatorio.',
  'The last name field is required.': 'El campo de apellido es obligatorio.',
  'The name must be at least 2 characters.':
    'El nombre debe tener al menos 2 caracteres.',
  'The name may not be greater than 50 characters.':
    'El nombre no puede tener más de 50 caracteres.',

  // Phone validation errors
  'The phone field is required.': 'El campo de teléfono es obligatorio.',
  'The phone number format is invalid.':
    'El formato del número de teléfono es inválido.',
  'The phone number must be a valid phone number.':
    'El número de teléfono debe ser válido.',

  // General validation errors
  'The given data was invalid.': 'Los datos proporcionados son inválidos.',
  'The selected option is invalid.': 'La opción seleccionada es inválida.',
  'This field is required.': 'Este campo es obligatorio.',
  'The field must be a string.': 'El campo debe ser texto.',
  'The field must be a number.': 'El campo debe ser un número.',
  'The field must be a valid date.': 'El campo debe ser una fecha válida.',

  // Authentication specific errors
  'Invalid credentials.': 'Credenciales inválidas.',
  'The provided credentials are incorrect.':
    'Las credenciales proporcionadas son incorrectas.',
  'Account not verified.': 'Cuenta no verificada.',
  'Email verification required.':
    'Se requiere verificación de correo electrónico.',
  'Account has been suspended.': 'La cuenta ha sido suspendida.',

  // Terms and conditions
  'You must accept the terms and conditions.':
    'Debes aceptar los términos y condiciones.',
  'The terms field is required.': 'El campo de términos es obligatorio.',

  // Age validation
  'You must be at least 18 years old.': 'Debes tener al menos 18 años.',
  'The date of birth is required.': 'La fecha de nacimiento es obligatoria.',
  'The date of birth must be a valid date.':
    'La fecha de nacimiento debe ser una fecha válida.',
  'Please wait before retrying.': 'Por favor, espera antes de reintentar.',
};
